// extracted by mini-css-extract-plugin
export default {"modalHeader":"ModalHeaders_modalHeader__ak8Yl","modalHeader2":"ModalHeaders_modalHeader2__uhmeq","placeHolderShimmer":"ModalHeaders_placeHolderShimmer__oXkyn"};